import { Typography } from '@braskai/ui-kit';

import { Stack } from '@mui/material';

type PromoCodeLineProps = {
  code: string;
  currency: string;
  discountAmount: number;
  formatPrice: (amount: number, currency: string) => string;
};

export const PromoCodeLine = ({ code, currency, discountAmount, formatPrice }: PromoCodeLineProps) => {
  if (!discountAmount) return null;

  return (
    <Stack alignItems="center" direction="row" justifyContent="space-between">
      <Typography color="primary.700" variant="body-2">
        Promo code {code}
      </Typography>
      <Typography color="primary.700" variant="body-2">
        -{formatPrice(discountAmount, currency)}
      </Typography>
    </Stack>
  );
};
